module.exports = __webpack_public_path__ + "static/media/1.309e8d9e.jpg";